export class Address {
  address_type!: string;
  street!: string;
  city!: string;
  state!: string;
  postal_code!: string;
  country!: string;
  has_proof_of_address!: boolean;
  proof_of_address?: string;
  proof_of_address_status!: string;
  proof_of_address_failure_reason!: string;
  status?: string;

  created_at?: string;
  updated_at?: string;
  requested_at?: string;
  submitted_at?: string;
  under_review_at?: string;
  approved_at?: string;
  rejected_at?: string;
  restricted_at?: string;

  constructor(data: any = {}) {
    this.build(data);
  }

  private build(data: any = {}) {
    this.address_type = data.address_type;
    this.street = data.street;
    this.city = data.city;
    this.state = data.state;
    this.postal_code = data.postal_code;
    this.country = data.country;
    this.has_proof_of_address = Boolean(data.has_proof_of_address ?? data.proof_of_address);
    this.proof_of_address = data.proof_of_address;
    this.proof_of_address_status = data.proof_of_address_status;
    this.proof_of_address_failure_reason = data.proof_of_address_failure_reason;
    this.status = data.status || data.proof_of_address_status;

    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.requested_at = data.requested_at;
    this.submitted_at = data.submitted_at;
    this.under_review_at = data.under_review_at;
    this.approved_at = data.approved_at;
    this.rejected_at = data.rejected_at;
    this.restricted_at = data.restricted_at;
  }

  isValid() {
    return (
      this.street && this.state && this.postal_code && this.city && this.country
    );
  }
}
